<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">All Service Fees</h5>
                <p class="mb-0 text-sm">
                  Below the list of service fees.
                </p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto">
                  <button
                    class="mb-0 btn bg-gradient-success btn-sm me-2"
                    @click="showAddForm()"
                    >+&nbsp; Add New</button>                  
                  <Modal 
                  :show="modal.isShowAddForm" 
                  :titlePage="modal.titlePage"
                  :subtitlePage="modal.subtitlePage"
                  :submitButtonName="modal.submitButtonName"
                  :onSubmit="onSubmit"
                  :onCancel="onCancel"
                  :showLoading="showLoading"
                  :hideLoading="hideLoading"
                  :showFailed="showFailed"
                  :recordProps="record" />
               
                  <button
                    class="mt-1 mb-0 btn btn-outline-success btn-sm export mt-sm-0"
                    data-type="csv"
                    type="button"
                    v-if="false"
                    name="button"
                  >
                    Export
                  </button>
                </div>
              </div>
            </div>
            
          </div>
          <div class="px-0 pb-0 card-body">
            <div class="table-responsive">
              <div class="dataTable-wrapper dataTable-loading no-footer sortable searchable fixed-columns search-results">
                <div class="dataTable-top">
                  <div class="dataTable-dropdown">
                    <label>
                      <select class="dataTable-selector form-select form-select-sm" v-model="limitPerPage" @change="getAllAPI()">
                        <option v-for="item in perPages" :value="item" :key="item" >{{ item }}</option>                        
                      </select>
                      entries per page
                    </label>
                    </div>
                    <div class="dataTable-search">
                      <input class="dataTable-input" placeholder="Search..." type="text" v-model="search" @change="getAllAPI()">
                    </div>
                  </div>
                  <div class="dataTable-container">
                    <table id="products-list" class="table table-flush dataTable-table">
                      <thead class="thead-light">
                        <tr>
                          <th>
                            No. 
                          </th>
                          <th>
                            Amount
                          </th>
                          <th>
                            Sas Fee Type
                          </th>
                          <th>
                            Product Type
                          </th>
                          <th>
                            Active?
                          </th>
                          <th>
                            Created At
                          </th>
                          <th>
                            Updated At
                          </th>
                          <th>
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(record, index) in records" :key="record.id">
                          <td class="text-sm">{{ ((this.currentPage-1)*this.limitPerPage) + index+1 }}</td>
                          <td class="text-sm">{{ record.amount }}</td>
                          <td class="text-sm">{{ record.sas_fee_type }}</td>
                          <td class="text-sm">{{ record.product_type }}</td>
                          <td class="text-sm">{{ record.is_active ? 'Yes' : 'No' }}</td>
                          <td class="text-sm">{{ dateTime(record.created_at) }}</td>
                          <td class="text-sm">{{ dateTime(record.updated_at) }}</td>
                          <td class="text-sm">
                            <a href="javascript:;" @click="showEditForm(record)" class="mx-3" data-bs-toggle="tooltip" data-bs-original-title="Edit Service Fee">
                              <i class="fas fa-edit text-secondary" aria-hidden="true"></i>
                            </a>
                            <a href="javascript:;" @click="confirmationDelete(record.id)" data-bs-toggle="tooltip" data-bs-original-title="Delete Service Fee">
                              <i class="fas fa-trash text-secondary" aria-hidden="true"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="dataTable-bottom">
                    <div class="dataTable-info">Showing {{ totalRecords == 0 ? 0 : currentPage }} to {{ shownData() }} of {{  totalRecords }} entries</div>
                      <nav class="dataTable-pagination">
                        <argon-pagination color="success" size="sm">
                          <argon-pagination-item prev v-if="currentPage > 1" @click="onChangePagination(currentPage-1)"/>
                          <argon-pagination-item v-for="item in dataPerPages()" :label="String(item)" :active="item == currentPage" :key="item" @click="onChangePagination(item)"/>
                          <argon-pagination-item next v-if="currentPage < dataPerPages()" @click="onChangePagination(currentPage+1)"/>
                        </argon-pagination>
                      </nav>
                    </div>
                 
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import ServiceFeeService from "@/services/service-fees.service.js";
  import ArgonPagination from "@/components/ArgonPagination.vue";
  import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
  import showSwalConfirmationDelete from "@/mixins/showSwal.js";
  import Modal from "./Modal.vue";

  import { ref } from 'vue';
  import { toast } from 'vue3-toastify';

  const toastId = ref('');

  const moment = require('moment');

  export default {
    name: "ServiceFeeList",
    data() {
      return {
        perPages: [5, 10, 15, 20, 25],
        records: [],
        totalRecords: 0,        
        limitPerPage: 5,
        currentPage: 1,
        search: '',
        modal: {},
        record: null
      };
    },
    mixins: [showSwalConfirmationDelete],
    methods: {
      showEditForm(item) {
        this.record = item
        
        this.modal = {
          isShowAddForm: true,
          titlePage: "Edit Service Fee",
          subtitlePage: "Edit a Service Fee",
          submitButtonName: "Update Service Fee"
        }
      },
      showAddForm() {
        this.record = {sas_fee_type: 'percentage'}
        
        this.modal = {
          isShowAddForm: true,
          titlePage: "New Service Fee",
          subtitlePage: "Create new Service Fee",
          submitButtonName: "Create Service Fee"
        }
      },
      onSubmit(data){
        this.onCancel()
        this.showLoading()
        data.amount = parseFloat(data.amount)

        if(this.record != null && this.record.id != null){
          this.updateAPI(data, this.record.id)
        }else{
          this.createAPI(data)
        }
      },
      updateAPI(data, recordId) {
        console.log({
          data,recordId
        })
        ServiceFeeService.update(data, recordId).then(e => {
          this.hideLoading()
          console.log(e)
          this.showSuccess("Update Successfully")
          this.getAllAPI()
        }).catch(e => {
          this.showFailed(e.response.data.code_message)           
        });
      },
      createAPI(data) {
        console.log({data})
        ServiceFeeService.create(data).then(e => {
          this.hideLoading()
          console.log(e)
          this.showSuccess("Create Successfully")
          this.getAllAPI()
        }).catch(e => {
          this.showFailed(e.response.data.code_message)           
        });
      },
      onCancel() {
        this.modal = {
          isShowAddForm: false
        }
      },
      showLoading(){
        toastId.value = toast.loading('Please wait...');
      },
      hideLoading(){
        setTimeout(() => {
          toast.remove(toastId.value)
        }, 1000); 
      },
      showSuccess(msg){
        toast.update(toastId.value, {
          render: msg,
          closeOnClick: true,
          closeButton: true,
          type: 'success',
          isLoading: false,
          autoClose: 3000
        });      
      },
      showFailed(e){
        toast.update(toastId.value, {
          render: e,
          closeOnClick: true,
          closeButton: true,
          type: 'error',
          isLoading: false,
          autoClose: 3000
        });
      },
      confirmationDelete(id){
        this.showSwalConfirmationDelete().then((result) => {
            console.log(result)
            if (result.value) {
              this.deleteRecord(id)
            }
          });
      },
      deleteRecord(id){
        this.showLoading()
        console.log({id})

        ServiceFeeService.delete(id).then(() => {
          this.showSuccess("delete Successfully")
          this.getAllAPI()
        }).catch(e => {
          this.showFailed(e.response.data.code_message)           
        });
      },
      dateTime(value) {
        return moment(value).format("DD MMM YYYY");
      },
      shownData() {
        const total = this.limitPerPage*this.currentPage
        return this.totalRecords > total ? total : this.totalRecords
      },
      dataPerPages() {
        const total = Math.ceil(this.totalRecords / this.limitPerPage)
        return total
      },
      onChangePagination(event) {
        this.currentPage = event
        this.getAllAPI()
      },
      getAllAPI(){
        const params = {
          limit: this.limitPerPage,
          page: this.currentPage,
          filter: this.search
        }

        ServiceFeeService.getAll(params).then(e => {
          const data = e.data
          this.records = data.margin_sas_fees
          this.totalRecords = data.count
        })
      }
    },
    components: {
      ArgonPagination,
      ArgonPaginationItem,
      Modal
    },
    mounted() {
      this.getAllAPI()
    },
  };
  </script>
  